// extracted by mini-css-extract-plugin
module.exports = {"content":"DataTable_content__1Dp9g","table":"DataTable_table__92zo1"};